import { atom } from "jotai";

/* 送信トークンを保持する */
export const contactAtom = atom<{
  fileTokens: string[];
  photoTokens: string[];
}>({
  fileTokens: [],
  photoTokens: []
});
contactAtom.debugLabel = "contactAtom";
